import axios from './index'

// Diş tedavisi (Tooth) uçları. Kaydet/Düzenle/Sil/Getir uçları clientapp ile ortaktır;
// liste için JSON dönen /Tooth/ListByCustomer kullanılır (tüm şubeler).
export default {
  getCustomerToothTreatments(customerId) {
    return axios.get('/Tooth/ListByCustomer?customerId=' + customerId)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  // Uç adı backend sözleşmesidir (GetToohTreatment); yazım hatası bilinçli olarak korunur.
  getToothTreatment(toothTreatmentId) {
    return axios.get('/Tooth/GetToohTreatment?toothTreatmentId=' + toothTreatmentId)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  insertToothTreatment(model) {
    return axios.post('/Tooth/Insert', model)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  editToothTreatment(model) {
    return axios.post('/Tooth/Edit', model)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  deleteToothTreatment(id) {
    return axios.post('/Tooth/Delete?id=' + id)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  downloadToothTreatmentPdf(id) {
    return axios.get('/Tooth/DataExportSingle?id=' + id, { responseType: 'arraybuffer' })
      .then((response) => {
        return response;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  getServiceWithRelatedProducts(serviceId) {
    return axios.get('/service/GetServiceWithRelatedProducts?serviceId=' + serviceId)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  getCustomerDiscountGroup(customerId) {
    return axios.get('/customer/getCustomerDiscountGroup?customerId=' + customerId)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  // Hizmet + ürün listesi (clientapp'teki diş hizmet seçimiyle aynı uç).
  getServiceAndProductList(staffId) {
    return axios.get('/entity/listJson?entityTypes=service,product&servicesStaffId=' + (staffId || ''))
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  }
}
